import React from 'react';
import {
  ExtractIcon,
} from '../Styled/Buttons/icons';
import meta from '../../const/meta';
import SubPage from '../MaterialUI/subpage';

const items = [
  {
    url: meta.doc.subscriptions.frontend,
    title: 'Казначейські виписки',
    icon: ExtractIcon,
    section: 'subscription',
    desc: 'Виписики з держ. казначейства',
  },
  {
    url: meta.doc.subscriptions412.frontend,
    title: 'Файли FT*.* (форма 412)',
    icon: ExtractIcon,
    section: 'subscription',
    desc: 'Файли FT*.* (форма 412)',
  },
  {
    url: meta.doc.grksubscriptions.frontend,
    title: 'Виписки ГРК',
    icon: ExtractIcon,
    section: 'subscription',
    desc: 'Файли ГРК',
  },
];
function SubscriptionsPage() {
  return <SubPage pageTitle="Виписки" items={items} />;
}

export default SubscriptionsPage;
